import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ReasonFormComponent } from '../reason-form/reason-form.component';
import { ReasonService } from '../../../Model/Reason/reason.service';

@Component({
  selector: 'app-reason',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule],
  templateUrl: './reason.component.html',
  styleUrl: './reason.component.scss'
})
export class ReasonComponent {
@ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  Reason : any[] = [];
  //Shift : any[] = [];
  //ShiftGroupData : any[] = []
  private modalService = inject(NgbModal);
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip : TooltipService,
    private toast : ToastService,
    private download : DownloadSampleService,
     private reason: ReasonService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  filter = {
    SelectType: '1',
    ESS_ResignationReasonMasterId: 0
  }
  
  ngOnInit(): void {
    this.GetData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  add(id: number) {
     if ((this.common.PageRight.IsAdd && id == 0) || (this.common.PageRight.IsEdit && id > 0)) {
      const modalRef = this.modalService.open(ReasonFormComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.id = id;

      modalRef.result.then((result: any) => {
        if (result) {
          this.GetData();
        }
      }).catch(() => {
        // Modal dismissed
      });
    }else{
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
  GetData() {
   this.isDisabled = true;
    this.reason.ESS_ResignationReasonMaster(this.filter).subscribe({
      next: (response) => {
        this.Reason = Object.values(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => {  this.isDisabled = false;},
      error: (error) => {
        this.isDisabled = false;
      },
     });
  }
}
